import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';

// Only the monetization meta (languages, onboarding hints) lives here now; push campaigns use
// pages/application/monetization/push/api.js.
const initialState = {
  languages: [],
  isLoading: false,
  error: false,
  /** From GET /monetization/:appId/meta — checklist + paths */
  onboardingHints: null,
};

const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    getMonetizationMetaStart(state) {
      state.isLoading = true;
    },

    getMonetizationMetaSuccess(state, action) {
      const { languages, onboardingHints } = action.payload;
      state.isLoading = false;
      state.languages = languages ?? [];
      state.onboardingHints = onboardingHints ?? null;
    },

    getMonetizationMetaError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default slice.reducer;

export const { getMonetizationMetaError, getMonetizationMetaSuccess, getMonetizationMetaStart } = slice.actions;

export function getMonetizationMeta(appId) {
  return async (dispatch) => {
    dispatch(getMonetizationMetaStart());
    try {
      const response = await axios.get(`/monetization/${appId}/meta`);
      dispatch(getMonetizationMetaSuccess(response));
    } catch (error) {
      dispatch(getMonetizationMetaError(error));
    }
  };
}
